import Toastr from "../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  lab_order: {},
  meta: { pagination: {} },
  saving: false,
};

let changes = null;

export default function labOrderReducer(state = DEFAULT_STATE, action) {
  const response =
    action.payload?.data ||
    action.payload?.response?.data ||
    action.payload?.response ||
    action.payload;

  let updatedRecord = {};

  switch (action.type) {
    case 'LAB_ORDER_LOAD_PENDING':
      return { ...state, saving: true };

    case 'LAB_ORDER_UPDATE_PENDING':
    case 'SEND_TO_VISION_WEB_CREATE_PENDING':
      return { ...state, saving: true };

    case 'LAB_ORDER_LOAD_REJECTED':
    case 'LAB_ORDER_UPDATE_REJECTED':
    case 'LAB_ORDER_BARCODE_SCAN_REJECTED':
    case 'SEND_TO_VISION_WEB_CREATE_REJECTED': {
      console.log('Rejected response:', action);
      console.log('Parsed response:', response);

      const errorMessage =
        response?.error ||
        response?.message ||
        response?.meta?.message ||
        'Something went wrong';

      Toastr.handleShow(
        false,
        errorMessage,
        response?.status_code || action.payload?.status_code || 422
      );

      return {
        ...state,
        saving: false,
      };
    }

    case 'LAB_ORDER_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false,
      };

      return { ...state, ...changes };

    case 'LAB_ORDER_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);

      updatedRecord = response.lab_order;

      changes = {
        lab_order: updatedRecord,
        saving: false,
      };

      return { ...state, ...changes };

    case 'LAB_ORDER_CREATE_REJECTED': {
      console.log('LAB_ORDER_CREATE_REJECTED action:', action);
      console.log('LAB_ORDER_CREATE_REJECTED payload:', action.payload);
      console.log('LAB_ORDER_CREATE_REJECTED response:', response);

      const errorMessage =
        response?.error ||
        response?.message ||
        response?.meta?.message ||
        'Unable to create lab order';

      Toastr.handleShow(
        false,
        errorMessage,
        response?.status_code || 422
      );

      return {
        ...state,
        saving: false,
      };
    }

    case 'LAB_ORDER_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);

      const createdRecord = response.lab_order;

      changes = {
        lab_order: createdRecord,
        saving: false,
      };

      return { ...state, ...changes };

    case 'SEND_TO_VISION_WEB_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);

      changes = {
        lab_order: response.lab_order,
        saving: false,
      };

      return {
        ...state,
        ...changes,
      };

    case 'LAB_ORDER_EDIT':
      changes = {
        editing: {
          id: action.id,
        },
      };

      return { ...state, ...changes };

    case 'LAB_ORDER_EDIT_CANCEL':
      changes = {
        editing: false,
        lab_order: {},
      };

      return { ...state, ...changes };

    default:
      return state;
  }
}